import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { VioletButton } from "@ui/violet-button/violet-button";
import { useWindowSize } from "usehooks-ts";

export const FundsMainNavBar: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { width } = useWindowSize();

  const isMobile = width <= 992;

  return (
    <div className="flex justify-between items-center w-full font-sf-pro text-lg mb-5">
      <div className="flex gap-3">
        <span className="text-violet-600 dark:text-white text-l md:text-xl py-2 px-3 border-b-2 border-violet-600 font-medium">
          {t("funds-list-table.nav-bar.menu.all")}
        </span>
      </div>
      <div className="flex gap-3 items-center">
        {isMobile ? null : (
          <VioletButton
            onClick={() => navigate("/create")}
            text={t("funds-list-table.nav-bar.new-fund")}
            className="py-4 px-32px"
          />
        )}
      </div>
    </div>
  );
};
